import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CustomSelect } from './components/CustomUI';
import { useShop } from './context/ShopContext';
// 👇 IMPORT NEW COMPONENT
import { AnimatedPrice } from './components/AnimatedPrice';

export default function BrowseAll() {
  const navigate = useNavigate();
  const { productsList, addToCart, currency, isLoaded } = useShop();
  
  const [sortOption, setSortOption] = useState('newest');
  const [sortedProducts, setSortedProducts] = useState([]);

  const sortOptions = [
    { value: 'newest', label: 'NEWEST' },
    { value: 'low-high', label: 'PRICE: LOW TO HIGH' },
    { value: 'high-low', label: 'PRICE: HIGH TO LOW' },
    { value: 'a-z', label: 'NAME: A - Z' },
  ];

  useEffect(() => {
    if (!isLoaded || !Array.isArray(productsList)) return;

    let sorted = [...productsList];

    const getPrice = (p) => {
      const variant = p.variants?.[0];
      if (!variant || !variant.prices) return 0;
      const priceObj = variant.prices[currency] || variant.prices['USD'];
      return priceObj ? priceObj.value : 0;
    };

    if (sortOption === 'low-high') sorted.sort((a, b) => getPrice(a) - getPrice(b));
    else if (sortOption === 'high-low') sorted.sort((a, b) => getPrice(b) - getPrice(a));
    else if (sortOption === 'a-z') sorted.sort((a, b) => a.name.localeCompare(b.name));
    else if (sortOption === 'newest') sorted.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
    
    setSortedProducts(sorted);
  }, [productsList, sortOption, currency, isLoaded]);

  return (
    <div className="browse-container fade-in">
      <div className="browse-header">
        <h1>ALL PRODUCTS</h1>
        <div className="sort-wrapper">
          <span className="sort-label">SORT BY:</span>
          <CustomSelect options={sortOptions} value={sortOption} onChange={setSortOption} />
        </div>
      </div>

      {!isLoaded ? (
        <div className="empty-state">LOADING CATALOG...</div>
      ) : sortedProducts.length === 0 ? (
        <div className="empty-state">NO PRODUCTS FOUND</div>
      ) : (
        <div className="product-grid">
          {sortedProducts.map((product) => {
            const firstVar = product.variants?.[0];
            const prices = firstVar?.prices || {};
            const priceObj = prices[currency] || prices['USD'] || { value: 0 };
            const img1 = product.images?.[0]?.url || '';
            const img2 = product.images?.[1]?.url || img1;

            return (
              <div key={product.id} className="product-card" onClick={() => navigate(`/product/${product.slug}`)}>
                <div className="product-image-wrapper">
                  <img src={img1} alt={product.name} className="primary" />
                  <img src={img2} alt={product.name} className="secondary" />
                  <button 
                    className="quick-add-btn"
                    onClick={(e) => { 
                      e.stopPropagation(); 
                      addToCart({
                        id: product.id,
                        name: product.name,
                        price: priceObj.value,
                        currency: currency,
                        image: img1,
                        variantId: firstVar?.id,
                        variantName: firstVar?.name
                      }); 
                    }}
                  >
                    <ArrowRight size={20} />
                  </button>
                </div>
                <div className="product-info">
                  <h3>{product.name}</h3>
                  {/* 👇 ANIMATED PRICE HERE */}
                  <div className="product-price">
                     <AnimatedPrice price={priceObj.value} currency={currency} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}